<form (ngSubmit)="onSave()" [formGroup]="formGroup">
  <h2 mat-dialog-title>
    @if (data.mode === 'edit') {
      {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.TITLE' | translate }}
    } @else {
      {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.EDIT_TITLE' | translate }}
    }
  </h2>

  <mat-dialog-content>
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.NAME_LABEL' | translate }}</glxy-label>
      <glxy-hint>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.NAME_HINT' | translate }}</glxy-hint>
      <input type="text" formControlName="description" matInput />
    </glxy-form-field>

    <glxy-form-field class="type-options">
      <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.TYPE_LABEL' | translate }}</glxy-label>
      <mat-radio-group formControlName="discountType" required>
        <mat-radio-button value="FIXED_AMOUNT_PER_UNIT">
          {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.TYPE_FIXED_AMOUNT_PER_UNIT' | translate }}
        </mat-radio-button>
        <mat-radio-button value="PERCENT_AMOUNT">
          {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.PERCENTAGE' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </glxy-form-field>

    @if (discountType.value === fixedAmountPerUnitDiscountType) {
      <span class="col-6 col-xs-6 amount">
        <glxy-form-field
          class="amount-input"
          [size]="'small'"
          [bottomSpacing]="'none'"
          [showLabel]="false"
          [prefixText]="currencySymbol"
        >
          <input
            matInput
            class="right-align-text"
            type="text"
            formControlName="amount"
            onwheel="this.blur()"
            (blur)="formatPrice(formGroup.get('amount'))"
            required
          />
          @if (amount.hasError('min') && amount.touched) {
            <glxy-error>{{
              'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.AMOUNT_MUST_BE_POSITIVE' | translate
            }}</glxy-error>
          }
        </glxy-form-field>
      </span>
    } @else {
      <span class="col-6 col-xs-6 amount">
        <glxy-form-field
          class="amount-input"
          [size]="'small'"
          [bottomSpacing]="'none'"
          [showLabel]="false"
          [prefixText]="'%'"
        >
          <input
            matInput
            class="right-align-text"
            type="number"
            formControlName="percentAmount"
            onwheel="this.blur()"
            required
          />
          @if (percentAmount.hasError('min') && percentAmount.touched) {
            <glxy-error>{{
              'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.PERCENT_MUST_BE_POSITIVE' | translate
            }}</glxy-error>
          }
        </glxy-form-field>
      </span>
    }

    @if (!data.hideDates) {
      <glxy-form-field class="duration">
        <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.DURATION' | translate }}</glxy-label>
        <mat-select formControlName="duration" required>
          <mat-option value="temporary">{{
            'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.DURATION_TEMPORARY' | translate
          }}</mat-option>
          <mat-option value="permanent">{{
            'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.DURATION_PERMANENT' | translate
          }}</mat-option>
        </mat-select>
      </glxy-form-field>

      @if (duration.value === 'temporary') {
        <div class="date-range">
          <glxy-form-field class="start-date">
            <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.START_DATE' | translate }}</glxy-label>
            <glxy-hint>{{
              'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.START_END_UTC' | translate
            }}</glxy-hint>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" required />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            @if (startDate.hasError('required') && startDate.touched) {
              <glxy-error>{{
                'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.START_DATE_HINT' | translate
              }}</glxy-error>
            }
          </glxy-form-field>

          <glxy-form-field>
            <glxy-label>{{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.END_DATE' | translate }}</glxy-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" [min]="minimumEndDate()" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            @if (endDate.hasError('matDatepickerMin')) {
              <glxy-error>
                {{ 'BILLING_SUBSCRIPTIONS.CREATE_SUBSCRIPTIONS.DISCOUNTS.END_DATE_AFTER_START' | translate }}
              </glxy-error>
            }
          </glxy-form-field>
        </div>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button type="submit" mat-flat-button color="primary" [disabled]="isLoading()" [showProgress]="isLoading()">
      {{ 'COMMON.ACTION_LABELS.CONFIRM' | translate }}
      <mat-progress-spinner
        progressIndicator
        mode="indeterminate"
        [attr.aria-label]="'BILLING.LOADING' | translate"
      ></mat-progress-spinner>
    </button>
  </mat-dialog-actions>
</form>
